export function addFormHelperText() {
    var verifyGlassScheduleDate = document.getElementsByClassName("verifyGlassScheduleDate");
    console.log(verifyGlassScheduleDate);
    if(verifyGlassScheduleDate.length > 0){
        var helperBlockSpanTagA = document.createElement("span");
        helperBlockSpanTagA.className = "helperText-a";
        var content1 = document.createTextNode("Need to confirm your Glass Schedule? View the ");
        helperBlockSpanTagA.appendChild(content1);

        verifyGlassScheduleDate[0].insertAdjacentElement("afterend", helperBlockSpanTagA);
    }
   

    var helperBlockA = document.getElementsByClassName("helperText-a");
    if (helperBlockA.length > 0) {
        var helperBlockLinkTag = document.createElement("a");
        var linkContent = document.createTextNode("Residential Service Schedule");
        helperBlockLinkTag.className = "helperText-link";
        helperBlockLinkTag.setAttribute('href', "https://pridedisposal.com/resources/curbside-schedule");
        helperBlockLinkTag.setAttribute('target', "_blank");
        helperBlockLinkTag.appendChild(linkContent);

        helperBlockA[0].insertAdjacentElement("afterend", helperBlockLinkTag);
    }

    var helperBlockLink = document.getElementsByClassName("helperText-link");
    if (helperBlockLink.length > 0) {
        var helperBlockSpanTagB = document.createElement("span");
        helperBlockSpanTagB.className = "helperText-b";
        var content2 = document.createTextNode(".");
        helperBlockSpanTagB.appendChild(content2);
        
        helperBlockLink[0].insertAdjacentElement("afterend", helperBlockSpanTagB);
    }
}


// WEBPACK FOOTER //
// ./resources/js/utils/formHelper.js